import classNames from 'classnames';
import { BurgerMenu } from 'layouts/main/sp-header/navigation/BurgerMenu';
import { ConnectedDiscoverItem } from 'layouts/main/sp-header/navigation/DiscoverItems';
import {
  ConnectedAddonManagementWorkspaceItem,
  ConnectedBatchQuoteWorkspaceItem,
  ConnectedDynamicQuoteWorkspaceItem,
  ConnectedEssentialQuoteWorkspaceItem,
  ConnectedPostTradeWorkspaceItem,
  ConnectedPriceImprovementBlotterItem,
  ConnectedQuoteBlotterItem,
  ConnectedScheduledQuotesBlotterWorkspaceItem,
  ConnectedTradeBlotterItem,
  ConnectedWebPriceItem,
  StaticQuoteWorkspaceItem,
  UnderlyingUniverseItem,
} from 'layouts/main/sp-header/navigation/PrimaryMarketItems';
import {
  ConnectedSecondaryMarketBatchWorkspaceItem,
  ConnectedSecondaryMarketOrdersBlotterItem,
  ConnectedSecondaryMarketPostTradeItem,
  ConnectedSecondaryMarketTradeBlotterItem,
  SecondaryMarketQuoteWorkspaceItem,
} from 'layouts/main/sp-header/navigation/SecondaryMarketItems';
import { useToggle } from 'usehooks-ts';

export function MobileNavigation() {
  const [isOpened, toggle] = useToggle();
  return (
    <>
      <BurgerMenu onClick={toggle} />
      <ul
        data-bs-popper="static"
        className={classNames('navbar-menu-dropdown dropdown-menu vh-100 overflow-auto', { show: isOpened })}
      >
        {isOpened && <MenuContent toggle={toggle} />}
      </ul>
    </>
  );
}

type MenuContentProps = Readonly<{
  toggle: () => void;
}>;

function MenuContent({ toggle }: MenuContentProps) {
  return (
    <>
      <ConnectedDiscoverItem onClick={toggle} />
      <div className="dropdown-divider" />
      <ConnectedEssentialQuoteWorkspaceItem isDropdownItem={false} onClick={toggle} />
      <StaticQuoteWorkspaceItem isDropdownItem={false} onClick={toggle} />
      <ConnectedDynamicQuoteWorkspaceItem isDropdownItem={false} onClick={toggle} />
      <ConnectedBatchQuoteWorkspaceItem isDropdownItem={false} onClick={toggle} />
      <ConnectedScheduledQuotesBlotterWorkspaceItem isDropdownItem={false} onClick={toggle} />
      <ConnectedPostTradeWorkspaceItem isDropdownItem={false} onClick={toggle} />
      <ConnectedAddonManagementWorkspaceItem isDropdownItem={false} onClick={toggle} />
      <ConnectedWebPriceItem onClick={toggle} isDropdownItem={false} />
      <UnderlyingUniverseItem isDropdownItem={false} onClick={toggle} />
      <ConnectedQuoteBlotterItem isDropdownItem={false} onClick={toggle} />
      <ConnectedTradeBlotterItem isDropdownItem={false} onClick={toggle} />
      <ConnectedPriceImprovementBlotterItem isDropdownItem={false} onClick={toggle} />
      <div className="dropdown-divider" />
      <SecondaryMarketQuoteWorkspaceItem isDropdownItem={false} onClick={toggle} />
      <ConnectedSecondaryMarketBatchWorkspaceItem isDropdownItem={false} onClick={toggle} />
      <ConnectedSecondaryMarketOrdersBlotterItem isDropdownItem={false} onClick={toggle} />
      <ConnectedSecondaryMarketPostTradeItem isDropdownItem={false} onClick={toggle} />
      <ConnectedSecondaryMarketTradeBlotterItem isDropdownItem={false} onClick={toggle} />
    </>
  );
}
